// ! PORTRAITS
// ? Physical Portraits
// Column 1 Portraits
import Phy1_1 from '../../../assets/img/items/physical/Phy1-1.jpg';
import Phy1_2 from '../../../assets/img/items/physical/Phy1-2.jpg';
import Phy1_3 from '../../../assets/img/items/physical/Phy1-3.jpg';
import Phy1_4 from '../../../assets/img/items/physical/Phy1-4.jpg';
import Phy1_5 from '../../../assets/img/items/physical/Phy1-5.jpg';
import Phy1_6 from '../../../assets/img/items/physical/Phy1-6.jpg';
// Column 2 Portraits
import Phy2_1 from '../../../assets/img/items/physical/Phy2-1.jpg';
import Phy2_2 from '../../../assets/img/items/physical/Phy2-2.jpg';
import Phy2_3 from '../../../assets/img/items/physical/Phy2-3.jpg';
import Phy2_4 from '../../../assets/img/items/physical/Phy2-4.jpg';
import Phy2_5 from '../../../assets/img/items/physical/Phy2-5.jpg';
import Phy2_6 from '../../../assets/img/items/physical/Phy2-6.jpg';
import Phy2_7 from '../../../assets/img/items/physical/Phy2-7.jpg';
import Phy2_8 from '../../../assets/img/items/physical/Phy2-8.jpg';
import Phy2_9 from '../../../assets/img/items/physical/Phy2-9.jpg';
import Phy2_10 from '../../../assets/img/items/physical/Phy2-10.jpg';
import Phy2_11 from '../../../assets/img/items/physical/Phy2-11.jpg';
import Phy2_12 from '../../../assets/img/items/physical/Phy2-12.jpg';
import Phy2_13 from '../../../assets/img/items/physical/Phy2-13.jpg';
// Column 3 Portraits
import Phy3_1 from '../../../assets/img/items/physical/Phy3-1.jpg';
import Phy3_2 from '../../../assets/img/items/physical/Phy3-2.jpg';
import Phy3_3 from '../../../assets/img/items/physical/Phy3-3.jpg';
import Phy3_4 from '../../../assets/img/items/physical/Phy3-4.jpg';
import Phy3_5 from '../../../assets/img/items/physical/Phy3-5.jpg';
import Phy3_6 from '../../../assets/img/items/physical/Phy3-6.jpg';
import Phy3_7 from '../../../assets/img/items/physical/Phy3-7.jpg';
import Phy3_8 from '../../../assets/img/items/physical/Phy3-8.jpg';
import Phy3_9 from '../../../assets/img/items/physical/Phy3-9.jpg';
import Phy3_10 from '../../../assets/img/items/physical/Phy3-10.jpg';
import Phy3_11 from '../../../assets/img/items/physical/Phy3-11.jpg';
import Phy3_12 from '../../../assets/img/items/physical/Phy3-12.jpg';

// ? Magical Portraits
// Column 1 Portraits
import Mag1_1 from '../../../assets/img/items/magical/Mag1-1.jpg';
import Mag1_2 from '../../../assets/img/items/magical/Mag1-2.jpg';
import Mag1_3 from '../../../assets/img/items/magical/Mag1-3.jpg';
import Mag1_4 from '../../../assets/img/items/magical/Mag1-4.jpg';
// Column 2 Portraits
import Mag2_1 from '../../../assets/img/items/magical/Mag2-1.jpg';
import Mag2_2 from '../../../assets/img/items/magical/Mag2-2.jpg';
import Mag2_3 from '../../../assets/img/items/magical/Mag2-3.jpg';
import Mag2_4 from '../../../assets/img/items/magical/Mag2-4.jpg';
import Mag2_5 from '../../../assets/img/items/magical/Mag2-5.jpg';
import Mag2_6 from '../../../assets/img/items/magical/Mag2-6.jpg';
import Mag2_7 from '../../../assets/img/items/magical/Mag2-7.jpg';
import Mag2_8 from '../../../assets/img/items/magical/Mag2-8.jpg';
import Mag2_9 from '../../../assets/img/items/magical/Mag2-9.jpg';
// Column 3 Portraits
import Mag3_1 from '../../../assets/img/items/magical/Mag3-1.jpg';
import Mag3_2 from '../../../assets/img/items/magical/Mag3-2.jpg';
import Mag3_3 from '../../../assets/img/items/magical/Mag3-3.jpg';
import Mag3_4 from '../../../assets/img/items/magical/Mag3-4.jpg';
import Mag3_5 from '../../../assets/img/items/magical/Mag3-5.jpg';
import Mag3_6 from '../../../assets/img/items/magical/Mag3-6.jpg';
import Mag3_7 from '../../../assets/img/items/magical/Mag3-7.jpg';
import Mag3_8 from '../../../assets/img/items/magical/Mag3-8.jpg';
import Mag3_9 from '../../../assets/img/items/magical/Mag3-9.jpg';
import Mag3_10 from '../../../assets/img/items/magical/Mag3-10.jpg';
import Mag3_11 from '../../../assets/img/items/magical/Mag3-11.jpg';

// ? Durable Portraits
// Column 1 Portraits
import Dur1_1 from '../../../assets/img/items/durable/Dur1-1.jpg';
import Dur1_2 from '../../../assets/img/items/durable/Dur1-2.jpg';
import Dur1_3 from '../../../assets/img/items/durable/Dur1-3.jpg';
import Dur1_4 from '../../../assets/img/items/durable/Dur1-4.jpg';
import Dur1_5 from '../../../assets/img/items/durable/Dur1-5.jpg';
import Dur1_6 from '../../../assets/img/items/durable/Dur1-6.jpg';
import Dur1_7 from '../../../assets/img/items/durable/Dur1-7.jpg';
import Dur1_8 from '../../../assets/img/items/durable/Dur1-8.jpg';
import Dur1_9 from '../../../assets/img/items/durable/Dur1-9.jpg';
// Column 2 Portraits
import Dur2_1 from '../../../assets/img/items/durable/Dur2-1.jpg';
import Dur2_2 from '../../../assets/img/items/durable/Dur2-2.jpg';
import Dur2_3 from '../../../assets/img/items/durable/Dur2-3.jpg';
import Dur2_4 from '../../../assets/img/items/durable/Dur2-4.jpg';
import Dur2_5 from '../../../assets/img/items/durable/Dur2-5.jpg';
import Dur2_6 from '../../../assets/img/items/durable/Dur2-6.jpg';
import Dur2_7 from '../../../assets/img/items/durable/Dur2-7.jpg';
import Dur2_8 from '../../../assets/img/items/durable/Dur2-8.jpg';
import Dur2_9 from '../../../assets/img/items/durable/Dur2-9.jpg';
import Dur2_10 from '../../../assets/img/items/durable/Dur2-10.jpg';
import Dur2_11 from '../../../assets/img/items/durable/Dur2-11.jpg';
// Column 3 Portraits
import Dur3_1 from '../../../assets/img/items/durable/Dur3-1.jpg';
import Dur3_2 from '../../../assets/img/items/durable/Dur3-2.jpg';
import Dur3_3 from '../../../assets/img/items/durable/Dur3-3.jpg';
import Dur3_4 from '../../../assets/img/items/durable/Dur3-4.jpg';
import Dur3_5 from '../../../assets/img/items/durable/Dur3-5.jpg';
import Dur3_6 from '../../../assets/img/items/durable/Dur3-6.jpg';
import Dur3_7 from '../../../assets/img/items/durable/Dur3-7.jpg';
import Dur3_8 from '../../../assets/img/items/durable/Dur3-8.jpg';
import Dur3_9 from '../../../assets/img/items/durable/Dur3-9.jpg';
import Dur3_10 from '../../../assets/img/items/durable/Dur3-10.jpg';
import Dur3_11 from '../../../assets/img/items/durable/Dur3-11.jpg';
import Dur3_12 from '../../../assets/img/items/durable/Dur3-12.jpg';
import Dur3_13 from '../../../assets/img/items/durable/Dur3-13.jpg';

// ? Boots Portraits
// Column 1 Portraits
import Bts1_1 from '../../../assets/img/items/boots/Bts1-1.jpg';
// Column 2 Portraits
import Bts2_1 from '../../../assets/img/items/boots/Bts2-1.jpg';
import Bts2_2 from '../../../assets/img/items/boots/Bts2-2.jpg';
import Bts2_3 from '../../../assets/img/items/boots/Bts2-3.jpg';
import Bts2_4 from '../../../assets/img/items/boots/Bts2-4.jpg';
import Bts2_5 from '../../../assets/img/items/boots/Bts2-5.jpg';
import Bts2_6 from '../../../assets/img/items/boots/Bts2-6.jpg';
// Column 3 Portraits
import Bts3_1 from '../../../assets/img/items/boots/Bts3-1.jpg';
import Bts3_2 from '../../../assets/img/items/boots/Bts3-2.jpg';

// ? Wards Portraits
// Column 1 Portraits
import Wrd1_1 from '../../../assets/img/items/wards/Wrd1-1.jpg';
import Wrd1_2 from '../../../assets/img/items/wards/Wrd1-2.jpg';
// Column 2 Portraits
import Wrd2_1 from '../../../assets/img/items/wards/Wrd2-1.jpg';
// Column 3 Portraits
import Wrd3_1 from '../../../assets/img/items/wards/Wrd3-1.jpg';
// const Wrd3_1 = '../../../assets/img/items/wards/Wrd3-1.jpg';


// ! PHYSICAL DB
export const physicalItems = [

  // ? COL 1 - [0-5]
  {
    id: "Phy1-1",
    portrait:  Phy1_1,
    name: "ATTACK TALONS",
    price: 500,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 10
      }
    ]
  },
  {
    id: "Phy1-2",
    portrait: Phy1_2,
    name: "SPIKED CLUB",
    price: 500,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 10
      },
      {
        name: "Attack Speed",
        value: 15
      }
    ]
  },
  {
    id: "Phy1-3",
    portrait: Phy1_3,
    name: "FLAMING CLAYMORE",
    price: 1400,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 21
      }
    ]
  },
  {
    id: "Phy1-4",
    portrait: Phy1_4,
    name: "PHANTOM CORSET",
    price: 600,
    category: "Physical",
    stats: [
      {
        name: "Agility",
        value: 6
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "Each Attack restores 5 Health."
      }
    ]
  },
  {
    id: "Phy1-5",
    portrait: Phy1_5,
    name: "HASTE GLOVES",
    price: 450,
    category: "Physical",
    stats: [
      {
        name: "Attack Speed",
        value: 15
      }
    ]
  },
  {
    id: "Phy1-6",
    portrait: Phy1_6,
    name: "LEECH MASK",
    price: 900,
    category: "Physical",
    uniquePassives: [
      {
        name: "",
        desc: "+15% Physical Life Steal"
      }
    ]
  },
  
  // ? COL 2 - [6 -18]
  {
    id: "Phy2-1",
    portrait:  Phy2_1,
    name: "SWIFT SPEAR",
    price: 2150,
    category: "Physical",
    stats: [
      {
        name: "Agility",
        value: 16
      },
      {
        name: "Attack Speed",
        value: 20
      }
    ],
    attributes: [
      {
        name: "Travel I",
        desc: "+10% Movement Speed"
      }
    ]
  },
  {
    id: "Phy2-2",
    portrait:  Phy2_2,
    name: "CAUSTIC THORN",
    price: 2550,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 30
      }
    ],
    uniquePassives: [
      {
        name: "Thorn Slash I",
        desc: "Your attacks reduce target's Armor by 30 for 5s, and cannot be stacked."
      }
    ]
  },
  {
    id: "Phy2-3",
    portrait:  Phy2_3,
    name: "SAVAGE MASK",
    price: 2100,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 18
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+15% Physical Life Steal"
      },
      {
        name: "Savagery I",
        desc: "Attacking an enemy hero unit grants 60 Movement Speed for melee heroes and 25 Movement Speed for ranged heroes. Lasts 2s."
      }
    ]
  },
  {
    id: "Phy2-4",
    portrait:  Phy2_4,
    name: "QUICKENING GEM",
    price: 2000,
    category: "Physical",stats: [
      {
        name: "Attack Speed",
        value: 40
      }
    ]
  },
  {
    id: "Phy2-5",
    portrait:  Phy2_5,
    name: "SCORCHING KNIFE",
    price: 2500,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 30
      },
      {
        name: "Attack Speed",
        value: 15
      }
    ],
    uniquePassives: [
      {
        name: "Scorch I",
        desc: "Each attack burns 20 Mana from the target, and deals the same amount in magical damage."
      }
    ]
  },
  {
    id: "Phy2-6",
    portrait:  Phy2_6,
    name: "RAPID TALONS",
    price: 1800,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 30
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting II",
        desc: "Reduces abilities cooldown by 10%. (Cap is 40%)"
      }
    ]
  },
  {
    id: "Phy2-7",
    portrait:  Phy2_7,
    name: "SOULEATER'S SWORD",
    price: 3000,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 30
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+12% Physical Life Steal"
      },
      {
        name: "Soul Eater (Offense)",
        desc: "Each last hit of enemy units grants 4 Damage and 0.5% Physical Life Steal. Max stack is 10. Effect disappears upon death."
      }
    ]
  },
  {
    id: "Phy2-8",
    portrait:  Phy2_8,
    name: "PIERCING HALBERD",
    price: 1800,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 25
      }
    ],
    attributes: [
      {
        name: "Pure Damage I",
        desc: "Transfers 12% damage of your attacks and physical abilities into Pure Damage."
      }
    ]
  },
  {
    id: "Phy2-9",
    portrait:  Phy2_9,
    name: "BITING BROADSWORD",
    price: 2150,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 30
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+15% Critical Chance"
      }
    ]
  },
  {
    id: "Phy2-10",
    portrait:  Phy2_10,
    name: "PRECISION STAVE",
    price: 2000,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 25
      },
      {
        name: "Attack Speed",
        value: 15
      }
    ],
    uniquePassives: [
      {
        name: "Precision Strike I",
        desc: "40% of your attacks will not miss."
      }
    ]
  },
  {
    id: "Phy2-11",
    portrait:  Phy2_11,
    name: "DEMON BLADE",
    price: 2400,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 50
      }
    ]
  },
  {
    id: "Phy2-12",
    portrait:  Phy2_12,
    name: "CRIPPLING PIERCER",
    price: 2150,
    category: "Physical",
    stats: [
      {
        name: "Strength",
        value: 16
      },
      {
        name: "Damage",
        value: 10
      }
    ],
    uniquePassives: [
      {
        name: "Demon Hack I",
        desc: "Grants each attack 15% chance to slow enemy's Attack Speed by 20 and Movement Speed by 20% for 3s."
      }
    ]
  },
  {
    id: "Phy2-13",
    portrait:  Phy2_13,
    name: "KNOCKOUT HAMMER",
    price: 3100,
    category: "Physical",
    stats: [
      {
        name: "Strength",
        value: 10
      },
      {
        name: "Damage",
        value: 30
      }
    ],
    uniquePassives: [
      {
        name: "Heavy Strike",
        desc: "Grants each attack 25% chance to stun the target for 0.5s for melee heroes and 10% chance to stun the target for 0.5s for ranged heroes. Both heroes deal an extra 50 damage."
      }
    ]
  },

  // ? COL 3 - [19 >]
  {
    id: "Phy3-1",
    portrait: Phy3_1,
    name: "MANA SLICER",
    price: 5800,
    category: "Physical",
    stats: [
      {
        name: "Agility",
        value: 20
      },
      {
        name: "Damage",
        value: 36
      },
      {
        name: "Attack Speed",
        value: 35
      }
    ],
    attributes: [
      {
        name: "Travel I",
        desc: "+10% Movement Speed"
      }
    ],
    uniquePassives: [
      {
        name: "Scorch II",
        desc: "Each basic attack burns 40 Mana on targets and deals the same amount in magical damage."
      }
    ],
    activeAbility: {
      name: "Body Breaker",
      desc: "Immediately deals 250 + Agility x2 magical damage to the target and slows Movement Speed by 30% for 3s.",
      cooldown: 30,
      castRange: 600
    }
  },
  {
    id: "Phy3-2",
    portrait: Phy3_2,
    name: "REAPER MASK",
    price: 5500,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 45
      },
      {
        name: "Attack Speed",
        value: 25
      },
      {
        name: "Health",
        value: 250
      },
      {
        name: "All Attributes",
        value: 10
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+20% Physical Life Steal"
      },
      {
        name: "Savagery II",
        desc: "After attacks an enemy hero, increases Movement Speed by 90 and reduces target's Movement Speed by 30% for 2s for melee heroes, or increases Movement Speed by 40 and reduces target's Movement Speed by 12% for ranged heroes. Effect does not stack."
      }
    ]
  },
  {
    id: "Phy3-3",
    portrait: Phy3_3,
    name: "BICOLOR TWIN SWORDS",
    price: 4300,
    category: "Physical",
    stats: [
      {
        name: "Stength",
        value: 16
      },
      {
        name: "Agility",
        value: 16
      },
      {
        name: "Damage",
        value: 25
      },
      {
        name: "Attack Speed",
        value: 25
      }
    ],
    attributes: [
      {
        name: "Travel II",
        desc: "+12% Movement Speed"
      }
    ],
    uniquePassives: [
      {
        name: "Demon Hack II",
        desc: "Grants each attack 30% chance to slow enemy's Attack Speed by 35 and Movement Speed by 35% for melee heroes, or 20 Attack Speed and 20% Movement Speed for ranged heroes. Lasts 3s."
      }
    ]
  },
  {
    id: "Phy3-4",
    portrait: Phy3_4,
    name: "RAGNAROK CANNON",
    price: 5750,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 100
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "Grants each attack +20% chance to deal critical damage."
      },
      {
        name: "",
        desc: "Increases critical damage to 250%."
      }
    ]
  },
  {
    id: "Phy3-5",
    portrait: Phy3_5,
    name: "SHAPESHIFTER'S AXE",
    price: 4250,
    category: "Physical",
    stats: [
      {
        name: "Agility",
        value: 18
      },
      {
        name: "Damage",
        value: 30
      },
      {
        name: "Attack Speed",
        value: 20
      }
    ],
    attributes: [
      {
        name: "Travel I",
        desc: "+10% Movement Speed"
      }
    ],
    activeAbility: {
      name: "Shapeshift",
      desc: "Activate to create 1 illusion of your hero that last for 10s. Illusions deal 75%/50% melee/ranged damage and take 200%/250% melee/ranged damage.",
      manaCost: 50,
      cooldown: 30
    }
  },
  {
    id: "Phy3-6",
    portrait: Phy3_6,
    name: "DECIMATION MACE",
    price: 6000,
    category: "Physical",
    stats: [
      {
        name: "Strength",
        value: 10
      },
      {
        name: "Damage",
        value: 30
      },
      {
        name: "Health",
        value: 300
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+15 Spell Resist"
      },
      {
        name: "Heavy Strike",
        desc: "25% chance to stun for 0.5s on melee basic attacks and 10% chance to stun for 0.5s on ranged basic attacks. Heavy Strike deals 50 on-hit physical damage."
      },
      {
        name: "Exorcism I",
        desc: "If your Health is below 35% after taking magical damage, you take 20% less magical damage for 4s. Auto Cooldown is 30s."
      }
    ],
    activeAbility: {
      name: "Setting Sun",
      desc: "Deals 120 plus 8% Target's Max Health magical damage to all enemy units in the nearby area, causing Movement Slow by 70% and reducing their damage output by 30%. Lasts 1.5s.",
      cooldown: 45,
      effectRadius: 450
    }
  },
  {
    id: "Phy3-7",
    portrait: Phy3_7,
    name: "BUTTERFLY WINGS",
    price: 6000,
    category: "Physical",
    stats: [
      {
        name: "Agility",
        value: 30
      },
      {
        name: "Damage",
        value: 45
      },
      {
        name: "Attack Speed",
        value: 40
      }
    ],
    attributes: [
      {
        name: "Travel I",
        desc: "+10% Movement Speed"
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+35% Dodge Chance. (Cap is 35%)"
      }
    ]
  },
  {
    id: "Phy3-8",
    portrait: Phy3_8,
    name: "DEATH CLAW",
    price: 5000,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 40
      },
      {
        name: "Strength",
        value: 16
      }
    ],
    attributes: [
      {
        name: "True Strike II",
        desc: "Transfers 25% damage of your attacks and physical abilities into Pure Damage."
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting III",
        desc: "Reduces abilities cooldown by 15%. (Cap is 40%)"
      }
    ]
  },
  {
    id: "Phy3-9",
    portrait: Phy3_9,
    name: "SHATTERING SPIKE",
    price: 5100,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 75
      }
    ],
    attributes: [
      {
        name: "Pure Damage II",
        desc: "Transfers 30% damage of your attacks and physical abilities into Pure Damage."
      }
    ]
  },
  {
    id: "Phy3-10",
    portrait: Phy3_10,
    name: "METRONOME STAFF",
    price: 5300,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 81
      },
      {
        name: "Attack Speed",
        value: 10
      }
    ],
    uniquePassives: [
      {
        name: "Precision Strike II",
        desc: "75% chance that your attacks will not miss."
      },
      {
        name: "Head Smack",
        desc: "Each attack deals 4% of target's Max Health magical damage."
      }
    ]
  },
  {
    id: "Phy3-11",
    portrait: Phy3_11,
    name: "EXECUTIONER'S CUT",
    price: 6000,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 60
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+25% Physical Life Steal"
      },
      {
        name: "Fast Casting III",
        desc: "Reduces abilities cooldown by 15%. (Cap is 40%)"
      },
      {
        name: "Soul Eater (Offense)",
        desc: "Each enemey unit last hit grants 5 Attack Damage and 1% Physical Life Steal. Max stack is 10. Effect disappears upon death. (Inherits stacks from Souleater Sword)"
      }
    ]
  },
  {
    id: "Phy3-12",
    portrait: Phy3_12,
    name: "CORROSIVE CLEAVER",
    price: 5300,
    category: "Physical",
    stats: [
      {
        name: "Damage",
        value: 60
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting II",
        desc: "Reduces abilities cooldown by 10%. (Cap is 40%)"
      },
      {
        name: "Thorn Slash II",
        desc: "Your attacks reduce target's Armor by 30 for 5s. (Can be stacked 3 times to reduce 90 Armor)"
      }
    ]
  }
]

// ! MAGICAL DB
export const magicalItems = [

  // ? COL 1 - [0-3]
  {
    id: "Mag1-1",
    portrait:  Mag1_1,
    name: "SORCERER'S GEM",
    price: 500,
    category: "Magical",
    stats: [
      {
        name: "Mana Regen",
        value: 50,
        type: "percent"
      }
    ]  
  },
  {
    id: "Mag1-2",
    portrait: Mag1_2,
    name: "PROFESSOR'S EMBLEM",
    price: 600,
    category: "Magical",
    stats: [
      {
        name: "Intelligence",
        value: 6
      },
      {
        name: "Mana Regen",
        value: 25,
        type: "percent"
      }
    ]  
  },
  {
    id: "Mag1-3",
    portrait: Mag1_3,
    name: "AMPLIFICATION RING",
    price: 900,
    category: "Magical",
    stats: [
      {
        name: "Spell Power",
        value: 15
      }
    ]  
  },
  {
    id: "Mag1-4",
    portrait: Mag1_4,
    name: "MANA PEARL",
    price: 450,
    category: "Magical",
    stats: [
      {
        name: "Mana",
        value: 150
      }
    ]  
  },

  // ? COL 2 - [4 -12]
  {
    id: "Mag2-1",
    portrait:  Mag2_1,
    name: "GOD HAND",
    price: 3500,
    category: "Magical",
    stats: [
      {
        name: "Intelligence",
        value: 15
      },
      {
        name: "Spell Power",
        value: 40
      }
    ],
    activeAbility: {
      name: "God Hand",
      desc: "Activate to emit a powerful burst to a target enemy unit, dealing 400 magical damage. Every 1 Spell Power increases 1 magical damage of God Hand",
      manaCost: 180,
      cooldown: 30,
      castRange: 800
    }
  },
  {
    id: "Mag2-2",
    portrait:  Mag2_2,
    name: "REGEN BEAD",
    price: 1750,
    category: "Magical",
    stats: [
      {
        name: "Health Regen",
        value: 5
      },
      {
        name: "Mana Regen",
        value: 75,
        type: "percent"
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting I",
        desc: "Reduces abilities cooldown by 5%. (Cap is 40%)"
      }
    ]
  },
  {
    id: "Mag2-3",
    portrait:  Mag2_3,
    name: "QUICKENING RING",
    price: 1800,
    category: "Magical",
    stats: [
      {
        name: "Spell Power",
        value: 30
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting II",
        desc: "Reduces abilities cooldown by 10%. (Cap is 40%)"
      }
    ]
  },
  {
    id: "Mag2-4",
    portrait:  Mag2_4,
    name: "WIZARD'S PRISM",
    price: 2050,
    category: "Magical",
    stats: [
      {
        name: "Health",
        value: 150
      },
      {
        name: "Mana",
        value: 150
      },
      {
        name: "Spell Power",
        value: 20
      }
    ],
    uniquePassives: [
      {
        name: "Break Spell I",
        desc: "Reduces 8 Spell Resist for all enemy units in a 1200 radius."
      }
    ]
  },
  {
    id: "Mag2-5",
    portrait:  Mag2_5,
    name: "CHRONOS CROWN",
    price: 3000,
    category: "Magical",
    stats: [
      {
        name: "Health",
        value: 300
      },
      {
        name: "Mana",
        value: 250
      },
      {
        name: "Spell Power",
        value: 40
      }
    ],
    uniquePassives: [
      {
        name: "Chronos Power",
        desc: "Increases 60 Health, 60 Mana and 6 Spell Power every minute. The maximum is 300 Health, 300 Mana and 30 Spell Power."
      }
    ]
  },
  {
    id: "Mag2-6",
    portrait:  Mag2_6,
    name: "ENHANCEMENT MASK",
    price: 1500,
    category: "Magical",
    stats: [
      {
        name: "Spell Power",
        value: 30
      }
    ]
  },
  {
    id: "Mag2-7",
    portrait:  Mag2_7,
    name: "MAGIC WARHAMMER",
    price: 2400,
    category: "Magical",
    stats: [
      {
        name: "Mana",
        value: 200
      },
      {
        name: "All Attributes",
        value: 5
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting II",
        desc: "Reduces abilities cooldown by 10%. (Cap is 40%)"
      },
      {
        name: "Charge I",
        desc: "After ability cast, increase base damage by 100% in next attack, auto cooldown is 3s. (This effect cannt stack with HEAVEN'S HAMMER or DEMON DIADEM)"
      }
    ]
  },
  {
    id: "Mag2-8",
    portrait:  Mag2_8,
    name: "MAGIC SUCKER",
    price: 3000,
    category: "Magical",
    stats: [
      {
        name: "Intelligence",
        value: 10
      },
      {
        name: "Spell Power",
        value: 35
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+20% Magical Life Steal"
      }
    ]
  },
  {
    id: "Mag2-9",
    portrait:  Mag2_9,
    name: "POWER ROD",
    price: 2150,
    category: "Magical",
    stats: [
      {
        name: "Intelligence",
        value: 16
      },
      {
        name: "Spell Power",
        value: 25
      },
      {
        name: "Mana Regen",
        value: 50,
        type: "percent"
      }
    ]
  },

  // ? COL 3 - [13 >]
  {
    id: "Mag3-1",
    portrait: Mag3_1,
    name: "FROZEN SHARD",
    price: 5675,
    category: "Magical",
    stats: [
      {
        name: "Intelligence",
        value: 25
      },
      {
        name: "All Attributes",
        value: 10
      },
      {
        name: "Mana Regen",
        value: 100,
        type: "percent"
      },
      {
        name: "Spell Power",
        value: 40
      }
    ],
    activeAbility: {
      name: "Frozen",
      desc: "Activate to freeze a target enemy hero for 0.5s. Afterwards, slows its movement speed by 40% for 3s. (Every 40 Intelligence increases 0.2s freezing duration)",
      manaCost: 150,
      cooldown: 36
    }
  },
  {
    id: "Mag3-2",
    portrait: Mag3_2,
    name: "DEMON DIADEM",
    price: 5200,
    category: "Magical",
    stats: [
      {
        name: "All Attributes",
        value: 10
      },
      {
        name: "Spell Power",
        value: 50
      },
      {
        name: "Mana",
        value: 300
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting III",
        desc: "Reduces abilities cooldown by 15%. (Cap is 40%)"
      },
      {
        name: "Charge II",
        desc: "After casting, gain 75+ (+100% Spell Power) magical bonus damage to next attack, with 3s cooldown for the effect."
      }
    ]
  },
  {
    id: "Mag3-3",
    portrait: Mag3_3,
    name: "CURSED URN",
    price: 5550,
    category: "Magical",
    stats: [
      {
        name: "Spell Power",
        value: 60
      },
      {
        name: "Health Regen",
        value: 5
      },
      {
        name: "Mana Regen",
        value: 100,
        type: "percent"
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting IV",
        desc: "Reduces abilities cooldown by 20%. (Cap is 40%)"
      },
      {
        name: "Curse",
        desc: "Magical damage abilities curse the enemies, dealing 6% of target's current Health in magical damage for 3s. Can be triggered again after 3s."
      }
    ]
  },
  {
    id: "Mag3-4",
    portrait: Mag3_4,
    name: "ALCHEMIST'S ORB",
    price: 4000,
    category: "Magical",
    stats: [
      {
        name: "Health",
        value: 250
      },
      {
        name: "Mana",
        value: 200
      },
      {
        name: "Spell Power",
        value: 50
      }
    ],
    uniquePassives: [
      {
        name: "Break Spell III",
        desc: "Reduces 15 Spell Resist for all enemy units in a 1200 radius."
      }
    ]
  },
  {
    id: "Mag3-5",
    portrait: Mag3_5,
    name: "PHAROAH'S SHROUD",
    price: 4700,
    category: "Magical",
    stats: [
      {
        name: "Intelligence",
        value: 27
      },
      {
        name: "Spell Power",
        value: 30
      },
      {
        name: "Armor",
        value: 90
      }
    ],
    uniquePassives: [
      {
        name: "Shifting Sands",
        desc: "Reduce Attack Speed for all enemy units in 1000 radius by 25 ."
      }
    ],
    activeAbility: {
      name: "Pharoah's Shroud",
      desc: "Your hero cannot move but summons a Pharoah's Coffin that absorbs up to 2000 (+150% Spell Power) damage for 3 seconds.",
      manaCost: 100,
      cooldown: 60
    }
  },
  {
    id: "Mag3-6",
    portrait: Mag3_6,
    name: "ZAKAR'S BLIGHT",
    price: 4500,
    category: "Magical",
    stats: [
      {
        name: "Spell Power",
        value: 60
      },
      {
        name: "Attack Speed",
        value: 35
      }
    ],
    attributes: [
      {
        name: "Travel I",
        desc: "+10% Movement Speed"
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting III",
        desc: "Reduces abilities cooldown by 15%. (Cap is 40%)"
      },
      {
        name: "Blight",
        desc: "Each basic attack deals on-hit 20 + 15% Spell Power magical damage."
      }
    ]
  },
  {
    id: "Mag3-7",
    portrait: Mag3_7,
    name: "DOME BREAKER",
    price: 6000,
    category: "Magical",
    stats: [
      {
        name: "Intelligence",
        value: 20
      },
      {
        name: "Spell Power",
        value: 110
      },
      {
        name: "Mana Regen",
        value: 100,
        type: "percent"
      }
    ],
    activeAbility: {
      name: "Dome Breaker",
      desc: "Deals 600 magical damage to target enemy hero unit, every 1 Spell Power grants 1 bonus magical damage.",
      manaCost: 250,
      cooldown: 35,
      castRange: 850
    }
  },
  {
    id: "Mag3-8",
    portrait: Mag3_8,
    name: "CRYSTAL HOOK",
    price: 4500,
    category: "Magical",
    stats: [
      {
        name: "Health",
        value: 350
      },
      {
        name: "Intelligence",
        value: 20
      },
      {
        name: "Spell Power",
        value: 60
      },
      {
        name: "Mana Regen",
        value: 50,
        type: "percent"
      }
    ],
    uniquePassives: [
      {
        name: "Slow",
        desc: "While dealing magical damage to the target (single/multiple), slows down their Movement Speed by 30% for 2s. Continuous or multi-step Spells slow down Movement Speed by 20% for 2s. Gear abilities cannot trigger this effect."
      }
    ]
  },
  {
    id: "Mag3-9",
    portrait: Mag3_9,
    name: "AGILITY WAND",
    price: 4000,
    category: "Magical",
    stats: [
      {
        name: "Intelligence",
        value: 16
      },
      {
        name: "Spell Power",
        value: 40
      },
      {
        name: "Health Regen",
        value: 5
      },
      {
        name: "Mana Regen",
        value: 100,
        type: "percent"
      }
    ],
    attributes: [
      {
        name: "Travel I",
        desc: "+10% Movement Speed"
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting IV",
        desc: "Reduces abilities cooldown by 20%. (Cap is 40%)"
      }
    ]
  },
  {
    id: "Mag3-10",
    portrait: Mag3_10,
    name: "QUICK PULSE",
    price: 6450,
    category: "Magical",
    stats: [
      {
        name: "Health",
        value: 350
      },
      {
        name: "Mana",
        value: 300
      },
      {
        name: "Spell Power",
        value: 70
      },
      {
        name: "Mana Regen",
        value: 100,
        type: "percent"
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+15% Magical Life Steal"
      },
      {
        name: "Fast Casting IV",
        desc: "Reduces abilities cooldown by 20%. (Cap is 40%)"
      }
    ]
  },
  {
    id: "Mag3-11",
    portrait: Mag3_11,
    name: "CONVERSION STAFF",
    price: 4200,
    category: "Magical",
    stats: [
      {
        name: "Spell Power",
        value: 60
      }
    ],
    uniquePassives: [
      {
        name: "Mana Spring",
        desc: "Increases Spell Power by 35%."
      }
    ]
  }
]

// ! DURABLE DB
export const durableItems = [

  // ? COL 1 - [0-8]
  {
    id: "Dur1-1",
    portrait:  Dur1_1,
    name: "RECOVERY RING",
    price: 600,
    category: "Durable",
    stats: [
      {
        name: "Health Regen",
        value: 6
      }
    ]
  },
  {
    id: "Dur1-2",
    portrait: Dur1_2,
    name: "KNIGHT'S WRISTGUARD",
    price: 600,
    category: "Durable",
    stats: [
      {
        name: "Strength",
        value: 6
      },
      {
        name: "Health Regen",
        value: 2
      }
    ]
  },
  {
    id: "Dur1-3",
    portrait: Dur1_3,
    name: "PLATEMAIL",
    price: 450,
    category: "Durable",
    stats: [
      {
        name: "Armor",
        value: 25
      }
    ]
  },
  {
    id: "Dur1-4",
    portrait: Dur1_4,
    name: "VITALITY BELT",
    price: 600,
    category: "Durable",
    stats: [
      {
        name: "All Attributes",
        value: 3
      }
    ]
  },
  {
    id: "Dur1-5",
    portrait: Dur1_5,
    name: "POWER AXE",
    price: 1000,
    category: "Durable",
    stats: [
      {
        name: "Strength",
        value: 10
      }
    ]
  },
  {
    id: "Dur1-6",
    portrait: Dur1_6,
    name: "LIFE PEARL",
    price: 900,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 200
      }
    ]
  },
  {
    id: "Dur1-7",
    portrait: Dur1_7,
    name: "REJUVENATION PEARL",
    price: 1200,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 200
      },
      {
        name: "Mana",
        value: 150
      }
    ]
  },
  {
    id: "Dur1-8",
    portrait: Dur1_8,
    name: "CHARMED CLOAK",
    price: 450,
    category: "Durable",
    uniquePassives: [
      {
        name: "",
        desc: "+10 Spell Resist"
      }
    ]
  },
  {
    id: "Dur1-9",
    portrait: Dur1_9,
    name: "EVASION RUNE",
    price: 1000,
    category: "Durable",
    uniquePassives: [
      {
        name: "",
        desc: "+15% Dodge Chance. (Cap is 35%)"
      }
    ]
  },
  
  // ? COL 2 - [9 -20]
  {
    id: "Dur2-1",
    portrait:  Dur2_1,
    name: "PARASITE SEED",
    price: 3000,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 400
      },
      {
        name: "Health Regen",
        value: 3
      }
    ],
    uniquePassives: [
      {
        name: "Soul Eater (Defense)",
        desc: "Each last hit on enemy unit grants +7 Health and +0.3 Health Regen. Killing troops and jungle creatures adds 1 stacks. Last hits on an enemy hero unit adds 10 stacks. Max Stack is 50."
      }
    ]
  },
  {
    id: "Dur2-2",
    portrait:  Dur2_2,
    name: "ENCHANTED ORB",
    price: 2100,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 300
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+15 Spell Resist"
      },
      {
        name: "Exorcism I",
        desc: "If your Health is lower than 35% by taking magical damage, futher magical damage is reduced by 20% for 4s. Auto Cooldown is 30s."
      }
    ]
  },
  {
    id: "Dur2-3",
    portrait:  Dur2_3,
    name: "BERSERK LOCKET",
    price: 3000,
    category: "Durable",
    stats: [
      {
        name: "All Attributes",
        value: 3
      },
      {
        name: "Health Regen",
        value: 6
      },
      {
        name: "Mana Regen",
        value: 100,
        type: "percent"
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting III",
        desc: "Reduces abilities cooldown by 15%. (Cap is 40%)"
      }
    ],
    activeAbility: {
      name: "Ring Dance",
      desc: "Increases 40% Movement Speed and 15 Attack Speed for all allies in 1000 radius for 4s.",
      manaCost: 100,
      cooldown: 30
    }
  },
  {
    id: "Dur2-4",
    portrait:  Dur2_4,
    name: "GIANT AXE",
    price: 3000,
    category: "Durable",
    stats: [
      {
        name: "Strength",
        value: 25
      },
      {
        name: "Health Regen",
        value: 10
      }
    ]
  },
  {
    id: "Dur2-5",
    portrait:  Dur2_5,
    name: "DIVINE SHIELD",
    price: 2150,
    category: "Durable",
    stats: [
      {
        name: "All Attributes",
        value: 6
      },
      {
        name: "Armor",
        value: 25
      }
    ],
    uniquePassives: [
      {
        name: "Divine Light",
        desc: "Grants 4 Health Regen to all allies in a 1000 radius."
      }
    ],
    activeAbility: {
      name: "Heal I",
      desc: "Activate to restore 250 Health to all allies in a 750 radius, while increasing their Armor by 12 for 15s. (Cannot Stack)",
      manaCost: 150,
      cooldown: 30
    }
  },
  {
    id: "Dur2-6",
    portrait:  Dur2_6,
    name: "SCORCHING MACE",
    price: 1850,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 250
      },
      {
        name: "Health Regen",
        value: 5
      }
    ],
    uniquePassives: [
      {
        name: "Scorch I",
        desc: "Scorches nearby enemies, dealing 20 Magical damage per second. (Deals 100% damage to troops and jungle creatures)"
      }
    ]
  },
  {
    id: "Dur2-7",
    portrait:  Dur2_7,
    name: "DODGE STONE",
    price: 2750,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 250
      },
      {
        name: "Mana",
        value: 200
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+20 Spell Resist"
      }
    ],
    activeAbility: {
      name: "Immunity I",
      desc: "Activate to become immune to stun, slow and trap effects. Lasts 3.5s for melee heroes and 2.5s for ranged heroes.",
      manaCost: 50,
      cooldown: 55
    }
  },
  {
    id: "Dur2-8",
    portrait:  Dur2_8,
    name: "RETRIBUTION MAIL",
    price: 2300,
    category: "Durable",
    stats: [
      {
        name: "Strength",
        value: 9
      },
      {
        name: "Agility",
        value: 9
      },
      {
        name: "Attack",
        value: 15
      }
    ],
    uniquePassives: [
      {
        name: "Revenge",
        desc: "Reflects 30% physical damage and 15% magical damage. Reflected damage is treated as pure damage."
      }
    ]
  },
  {
    id: "Dur2-9",
    portrait:  Dur2_9,
    name: "MITHRIL VEST",
    price: 1400,
    category: "Durable",
    stats: [
      {
        name: "Armor",
        value: 60
      }
    ]
  },
  {
    id: "Dur2-10",
    portrait:  Dur2_10,
    name: "ENERGY DIAMOND",
    price: 3300,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 450
      },
      {
        name: "Mana",
        value: 400
      },
      {
        name: "Health Regen",
        value: 3
      },
      {
        name: "Mana Regen",
        value: 50,
        type: "percent"
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting II",
        desc: "Reduces abilities cooldown by 10%. (Cap is 40%)"
      }
    ]
  },
  {
    id: "Dur2-11",
    portrait:  Dur2_11,
    name: "REVIVAL SPHERE",
    price: 2100,
    category: "Durable",
    stats: [
      {
        name: "All Attributes",
        value: 10
      }
    ]
  },

  // ? COL 3 - [21 >]
  {
    id: "Dur3-1",
    portrait: Dur3_1,
    name: "ACCURSED EYE",
    price: 4850,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 550
      },
      {
        name: "Mana",
        value: 250
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+35 Spell Resist"
      }
    ],
    activeAbility: {
      name: "Immunity II",
      desc: "Melee heroes become immune to stun, slow and root effects during 3.5s and ranged heroes during 2.5s and their magical damage taken is also reduced by 35%.",
      manaCost: 50,
      cooldown: 55
    }
  },
  {
    id: "Dur3-2",
    portrait: Dur3_2,
    name: "LIFE SPRING",
    price: 4300,
    category: "Durable",
    stats: [
      {
        name: "Armor",
        value: 50
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+20 Spell Resist"
      },
      {
        name: "",
        desc: "+25% Dodge Chance. (Cap is 35%)"
      }
    ],
    activeAbility: {
      name: "Health Spring",
      desc: "Increases 800 max Health for melee heroes or 400 max Health for ranged heroes for 10s. Self-only",
      manaCost: 50,
      cooldown: 30
    }
  },
  {
    id: "Dur3-3",
    portrait: Dur3_3,
    name: "KING'S ARMOR",
    price: 5250,
    category: "Durable",
    stats: [
      {
        name: "Armor",
        value: 90
      },
      {
        name: "Attack Speed",
        value: 35
      }
    ],
    uniquePassives: [
      {
        name: "Guardian Halo",
        desc: "Increases 30 armor of nearby ally units and buildings in a 1000 radius."
      },
      {
        name: "Destructive Pulse",
        desc: "Decreases 30 armor of nearby enemy units and buildings in a 1000 radius."
      },
      {
        name: "Ring Dance",
        desc: "Grants 15 Attack Speed to nearby ally units in a 1000 radius."
      }
    ]
  },
  {
    id: "Dur3-4",
    portrait: Dur3_4,
    name: "DELAY SHIELD",
    price: 4250,
    category: "Durable",
    stats: [
      {
        name: "Armor",
        value: 90
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+30% Dodge Chance. (Cap is 35%)"
      },
      {
        name: "Slow Aura",
        desc: "When attacked, reduces attacker's Movement Speed by 50 and Attack Speed by 30 for 1.5s."
      }
    ]
  },
  {
    id: "Dur3-5",
    portrait: Dur3_5,
    name: "DEMONIC COWL",
    price: 5600,
    category: "Durable",
    stats: [
      {
        name: "Strength",
        value: 30
      },
      {
        name: "Armor",
        value: 30
      },
      {
        name: "Health Regen",
        value: 10
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+25% Physical Life Steal"
      }
    ],
    activeAbility: {
      name: "Health Vampire",
      desc: "Activate to gain +125% bonus Physical Life Steal for 3s.",
      manaCost: 50,
      cooldown: 45
    }
  },
  {
    id: "Dur3-6",
    portrait: Dur3_6,
    name: "AWAKENING NECKLACE",
    price: 5000,
    category: "Durable",
    stats: [
      {
        name: "All Attributes",
        value: 25
      },
      {
        name: "Health",
        value: 150
      }
    ],
    attributes: [
      {
        name: "Awaken",
        desc: "Triggers a hero's most powerful latent forces, granting them an advantageous position."
      }
    ]
  },
  {
    id: "Dur3-7",
    portrait: Dur3_7,
    name: "FROST BITE",
    price: 4500,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 300
      },
      {
        name: "Mana",
        value: 250
      },
      {
        name: "Spell Power",
        value: 30
      },
      {
        name: "Armor",
        value: 60
      }
    ],
    uniquePassives: [
      {
        name: "Break Spell I",
        desc: "Reduces 8 Spell Resist for all enemy units in a 1200 radius."
      }
    ],
    activeAbility: {
      name: "Ice Rink",
      desc: "Activate to emit a freezing wave that deals Intelligence x3 magical damage to enemies in a 600 radius while slowing their movement speed by 40% for 3s.",
      manaCost: 50,
      cooldown: 30
    }
  },
  {
    id: "Dur3-8",
    portrait: Dur3_8,
    name: "SUMMONING ARMOR",
    price: 4900,
    category: "Durable",
    stats: [
      {
        name: "Strength",
        value: 19
      },
      {
        name: "Agility",
        value: 19
      },
      {
        name: "Intelligence",
        value: 10
      },
      {
        name: "Attack",
        value: 25
      }
    ],
    uniquePassives: [
      {
        name: "Revenge",
        desc: "Reflects 30% physical damage and 15% magical damage, all treated as pure damage."
      }
    ],
    activeAbility: {
      name: "Vengeful Deity",
      desc: "Summon a vengeful deity into you to increase damage reflection to 80% for 3 seconds.",
      manaCost: 40,
      cooldown: 30
    }
  },
  {
    id: "Dur3-9",
    portrait: Dur3_9,
    name: "PHOENIX HEART",
    price: 5500,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 300
      },
      {
        name: "Strength",
        value: 35
      }
    ],
    uniquePassives: [
      {
        name: "Rebirth",
        desc: "Restores 2.5% of Max Health per second. If damage is taken from an enemy hero, this ability is disabled for 3s for melee heroes, or 5s for ranged heroes."
      }
    ]
  },
  {
    id: "Dur3-10",
    portrait: Dur3_10,
    name: "CRYSTAL SHIELD",
    price: 4325,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 550
      },
      {
        name: "Mana",
        value: 250
      }
    ],
    attributes: [
      {
        name: "Iron Wall",
        desc: "Grants 50% chance to block 70 damage from each incoming attack for melee heroes, or 40 for ranged heroes."
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+20 Spell Resist"
      },
      {
        name: "Exorcism II",
        desc: "If your Health is lower than 35% by taking magical damage, further magical damage is reduced by 35% for 4s. Auto Cooldown is 60s."
      }
    ]
  },
  {
    id: "Dur3-11",
    portrait: Dur3_11,
    name: "HEAVEN'S HAMMER",
    price: 5000,
    category: "Durable",
    stats: [
      {
        name: "All Attributes",
        value: 10
      },
      {
        name: "Armor",
        value: 70
      },
      {
        name: "Mana",
        value: 300
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting III",
        desc: "Reduces abilities cooldown by 15%. (Cap is 40%)"
      },
      {
        name: "Heaven's Curse",
        desc: "Summons Crashing Thunder after ability is cast, your next attack deals 125% Base Damage as bonus damage, while slowing the target and nearby enemies movement speed by 30% for 2s in a 300 radius. (This effect cannot stack with DEMON DIADEM or MAGIC WARHAMMER, images do not apply this effect.)"
      }
    ]
  },
  {
    id: "Dur3-12",
    portrait: Dur3_12,
    name: "SEARING LONGSWORD",
    price: 5800,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 400
      },
      {
        name: "All Attributes",
        value: 10
      },
      {
        name: "Armor",
        value: 30
      },
      {
        name: "Health Regen",
        value: 8
      }
    ],
    uniquePassives: [
      {
        name: "Scorch II",
        desc: "Scorches neadby enemies, dealing (50 + 1% of target's Max Health) magical damage per second in a 200 radius. Max Damage: 100 (extra 50% damage to troops and jungle creatures)"
      }
    ]
  },
  {
    id: "Dur3-13",
    portrait: Dur3_13,
    name: "FORCEFIELD JEWEL",
    price: 5425,
    category: "Durable",
    stats: [
      {
        name: "Health",
        value: 600
      },
      {
        name: "Armor",
        value: 35
      }
    ],
    uniquePassives: [
      {
        name: "",
        desc: "+15 Spell Resist"
      },
      {
        name: "Crystal Halo",
        desc: "Increases Armor by 20 and Spell Resist by 15 for all allies within a 700 radius."
      }
    ]
  }
]

// ! BOOTS DB
export const bootsItems = [

  // ? COL 1 - [0]
  {
    id: "Bts1-1",
    portrait:  Bts1_1,
    name: "DASH BOOTS",
    price: 500,
    category: "Boots",
    uniquePassives: [
      {
        name: "Dash I",
        desc: "+50 Movement Speed"
      }
    ]
  },
  
  // ? COL 2 - [1 - 6]
  {
    id: "Bts2-1",
    portrait:  Bts2_1,
    name: "STAMINA BOOTS",
    price: 1600,
    category: "Boots",
    stats: [
      {
        name: "Health",
        value: 300
      }
    ],
    uniquePassives: [
      {
        name: "Dash II",
        desc: "+80 Movement Speed"
      }
    ]
  },
  {
    id: "Bts2-2",
    portrait:  Bts2_2,
    name: "WAR BOOTS",
    price: 1450,
    category: "Boots",
    stats: [
      {
        name: "Attack",
        value: 10
      },
      {
        name: "Attack Speed",
        value: 25
      }
    ],
    uniquePassives: [
      {
        name: "Dash II",
        desc: "+80 Movement Speed"
      }
    ]
  },
  {
    id: "Bts2-3",
    portrait:  Bts2_3,
    name: "GUARDIAN BOOTS",
    price: 1800,
    category: "Boots",
    stats: [
      {
        name: "Armor",
        value: 35
      }
    ],
    uniquePassives: [
      {
        name: "Dash II",
        desc: "+80 Movement Speed"
      },
      {
        name: "",
        desc: "Gives 70% chance to block 30/15 damage for melee/range"
      }
    ]
  },
  {
    id: "Bts2-4",
    portrait:  Bts2_4,
    name: "WIZARD BOOTS",
    price: 1700,
    category: "Boots",
    stats: [
      {
        name: "Spell Power",
        value: 20
      },
      {
        name: "Mana Regen",
        value: 25,
        type: "percent"
      }
    ],
    uniquePassives: [
      {
        name: "Dash II",
        desc: "+80 Movement Speed"
      },
      {
        name: "Fast Casting II",
        desc: "Reduces abilities cooldown by 10%. (Cap is 40%)"
      }
    ]
  },
  {
    id: "Bts2-5",
    portrait:  Bts2_5,
    name: "MANA BOOTS",
    price: 1500,
    category: "Boots",
    stats: [
      {
        name: "Mana",
        value: 250
      }
    ],
    uniquePassives: [
      {
        name: "Dash II",
        desc: "+80 Movement Speed"
      }
    ],
    activeAbility: {
      name: "Arcana I",
      desc: "Activate to restore 270 Mana to all allies in 1000 radius.",
      cooldown: 30
    }
  },
  {
    id: "Bts2-6",
    portrait:  Bts2_6,
    name: "SPEEDSTER BOOTS",
    price: 1600,
    category: "Boots",
    uniquePassives: [
      {
        name: "Dash III",
        desc: "+90 Movement Speed"
      },
      {
        name: "Holy Passage I",
        desc: "Grants an aura that increases 6% bonus Movement Speed to all allies in a 1000 radius."
      }
    ]
  },

  // ? COL 3 - [6 >]
  {
    id: "Bts3-1",
    portrait: Bts3_1,
    name: "DANCER'S GREAVES",
    price: 4800,
    category: "Boots",
    stats: [
      {
        name: "All Attributes",
        value: 3
      },
      {
        name: "Health Regen",
        value: 6
      },
      {
        name: "Mana Regen",
        value: 100,
        type: "percent"
      }
    ],
    uniquePassives: [
      {
        name: "Dash III",
        desc: "+90 Movement Speed"
      },
      {
        name: "Fast Casting III",
        desc: "Reduces abilities cooldown by 15%. (Cap is 40%)"
      },
      {
        name: "Holy Passage II",
        desc: "Increases Movement Speed by 8% for all allies in a 1000 radius."
      }
    ],
    activeAbility: {
      name: "Ring Dance",
      desc: "Inreases Movement Speed by 30% and 15 Attack Speed to all allies in a 1000 radius for 4s.",
      manaCost: 100,
      cooldown: 30
    }
  },
  {
    id: "Bts3-2",
    portrait: Bts3_2,
    name: "MERCY GUARDS",
    price: 4500,
    category: "Boots",
    stats: [
      {
        name: "Mana",
        value: 250
      },
      {
        name: "All Attributes",
        value: 6
      },
      {
        name: "Armor",
        value: 25
      }
    ],
    uniquePassives: [
      {
        name: "Dash II",
        desc: "+80 Movement Speed"
      },
      {
        name: "Divine Light",
        desc: "Grants 4 bonus Health Regen to all allies in a 1000 radius."
      }
    ],
    activeAbility: {
      name: "Heal II",
      desc: "Activate to recover 300 Health and 300 Mana for all allies in a 900 radius, while granting 12 bonus Armor for 15s.",
      manaCost: 100,
      cooldown: 30
    }
  }
]

// ! WARDS DB
export const wardsItems = [

  // ? COL 1 - [0-1]
  {
    id: "Wrd1-1",
    portrait:  Wrd1_1,
    name: "LIFE PEARL",
    price: 900,
    category: "Wards",
    stats: [
      {
        name: "Health",
        value: 200
      }
    ]
  },
  {
    id: "Wrd1-2",
    portrait:  Wrd1_2,
    name: "MANA PEARL",
    price: 450,
    category: "Wards",
    stats: [
      {
        name: "Mana",
        value: 150
      }
    ]
  },

  // ? COL 2 - [2]
  {
    id: "Wrd2-1",
    portrait:  Wrd2_1,
    name: "DETECTION GEM",
    price: 1800,
    category: "Wards",
    stats: [
      {
        name: "Health",
        value: 300
      },
      {
        name: "Mana",
        value: 200
      }
    ],
    attributes: [
      {
        name: "Observe I",
        desc: "Observer Ward Cooldown - 10s"
      },
      {
        name: "Spoils I",
        desc: "Whenever an enemy unit dies within 1000 radius and was not last-hit by you, you gain 3 coins, recover 10 health, and 5 mana."
      }
    ]
  },

  // ? COL 3 - [3]
  {
    id: "Wrd3-1",
    portrait: Wrd3_1,
    name: "TRUE SIGHT GEM",
    price: 4000,
    category: "Wards",
    stats: [
      {
        name: "Health",
        value: 500
      },
      {
        name: "Mana",
        value: 350
      }
    ],
    attributes: [
      {
        name: "Observe II",
        desc: "Observer Ward Cooldown - 10s. Placing an Observer Ward grants you True Sight for 10s."
      },
      {
        name: "Spoils II",
        desc: "Whenever an enemy unit dies within 1000 radius and was not last-hit by you, you gain 3 coins, recover 10 health, and 5 mana."
      }
    ],
    uniquePassives: [
      {
        name: "Fast Casting II",
        desc: "Reduces abilities cooldown by 10%. (Cap is 40%)"
      }
    ],
    specialEffects: [
      {
        name: "True Sight",
        desc: "Detects invisible enemy units within 1200 radius."
      },
    ]
  }
]